export const dispatchEvent = <T>(eventName: string, eventValue: T) => {
  window.dispatchEvent(new CustomEvent(eventName, { detail: eventValue }));
};
